<template>
  <div :class="{ wav: true }">
    <img src="@/assets/wave.svg" draggable="false" />
  </div>
</template>

<script>
export default {
  name: "WaveFooter",
};
</script>

<style></style>
